export default "__VITE_ASSET__lMKLcFO2__"